function initTabs() {
    const buttons = document.querySelectorAll("[data-toggle='tab']");
    for (let i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', function(e){
            for (let i = 0; i < buttons.length; i++) {
                buttons[i].classList.remove("btn--active")
            }

            const tabs = document.getElementsByClassName("tabs__item");
            for (let i = 0; i < tabs.length; i++) {
                tabs[i].classList.remove("tabs__active")
            }
            const tab = document.getElementById(e.target.getAttribute("data-target"))
            tab.classList.add("tabs__active")
            e.target.classList.add("btn--active")
        });
    }
}

initTabs()
